import { API_ROUTES } from "@/constants/api-routes";
import AxiosInstance from "@/api";
import { IAxiosResponse } from "@/types/axios-response";
import { ISubscriptionListParams, ISubscriptionListResponse } from "@/api/types/subscription";
import { serializeObject } from "@/utils/serializer";

export const GetSubscriptions = async (params: ISubscriptionListParams) => {
    const queryString = Object.keys(params).length > 0 ? `?${serializeObject(params)}` : "";

    const result = await AxiosInstance.get<ISubscriptionListResponse>(`${API_ROUTES.SUBSCRIPTIONS.LIST}${queryString}`);

    return result.data;
};

export interface FixUserStateBody {
    userId: number;
    activeTier?: string;
    hasSubscription?: boolean;
}

export const FixUserState = async (data: FixUserStateBody) => {
    const result = await AxiosInstance.post<IAxiosResponse<any>>(API_ROUTES.SUBSCRIPTIONS.FIX_USER_STATE, data);
    return result.data;
};
